import React from 'react';
import "./counselling.css"

function Counselling() {
  return (
    <div>
         <h2 className="counselling-heading">Counselling</h2>
        <div className='container'>
            {/* <h2>Counselling</h2> */}
      <p>Deepti offers counselling service to parents and children, with the help of trained and experience counsellor.</p>
      </div>
    </div>
  )
}

export default Counselling
